import React from 'react';
import './Header.css';
import riaz from '../../../images/mrriaz.png';
import Typist from 'react-typist';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faMapMarkedAlt, faPhoneAlt } from '@fortawesome/free-solid-svg-icons'


const Header = () => {
    return (
        <section id="home" className="row align-items-center container-fluid py-5">
            <div className="col-md-7">
                <h1 className="text-white">Hi I'm Riaz</h1>
                <Typist className='typist' cursor={{'hideWhenDone': true, 'hideWhenDoneDelay': 0}}>
                    <span className="typist">Engineer | Web Deveolpe</span>
                    <Typist.Backspace count={6} delay={1000} />
                    <span className="typist">veloper | Programmer</span>
                </Typist>
                <div className="social_link">
                    <ul>
                        <li>
                            <a href="mailto:monsur.riaz1@gmail.com">
                                <FontAwesomeIcon icon={faEnvelope} /> <span>monsur.riaz1@gmail.com</span>
                            </a>
                        </li>
                        <li>
                            <a href="#contact">
                                <FontAwesomeIcon icon={faPhoneAlt} /> <span>+8801794196888</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://goo.gl/maps/d8PDRmdyxP7sJvP59">
                                <FontAwesomeIcon icon={faMapMarkedAlt} /> <span>Dhaka, Bangladesh</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <button className="mt-3 mr-3 pl-0"><a href="#contact" className="btn px-4">Contact</a></button>

                <button className="mt-3"><a className="btn px-3" href="https://drive.google.com/u/6/uc?id=1Q7qjwPt6ec9gTh6pTdVnyJjcmp4F1ZuZ&export=download" target="blank">Download Resume</a></button>
            </div>
            <div className="col-md-5">
                <img className="header-img img-fluid" src={riaz} alt=""/>
            </div>
        </section>
    );
};

export default Header;